module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "mu-overlay-fade"
    }
  }, [(_vm.show) ? _c('div', {
    staticClass: "mu-overlay",
    style: (_vm.overlayStyle),
    on: {
      "click": _vm.handleClick,
      "touchmove": _vm.prevent
    }
  }) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-03ea2d31"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/muse-ui/src/internal/popup/overlay.vue
// module id = 412
// module chunks = 1